import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = 'https://asia-northeast3-nawaplay-6dadb.cloudfunctions.net/api';

const initialDepartment = { department: '', matchDate: '', location: '', status: '' };

const AddTournament = () => {
  const [form, setForm] = useState({
    name: '',
    organization: '',
    startDate: '',
    endDate: '',
    status: '',
    detailUrl: '',
    departments: [ { ...initialDepartment } ],
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleDeptChange = (idx, e) => {
    const newDepts = form.departments.map((d, i) =>
      i === idx ? { ...d, [e.target.name]: e.target.value } : d
    );
    setForm({ ...form, departments: newDepts });
  };

  const addDepartment = () => {
    setForm({ ...form, departments: [...form.departments, { ...initialDepartment }] });
  };

  const removeDepartment = idx => {
    setForm({ ...form, departments: form.departments.filter((_, i) => i !== idx) });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      // POST 요청 (백엔드에 POST /tournaments 필요)
      await axios.post(`${API_BASE_URL}/tournaments`, form);
      setSuccess(true);
      setForm({
        name: '', organization: '', startDate: '', endDate: '', status: '', detailUrl: '', departments: [ { ...initialDepartment } ]
      });
    } catch (err) {
      setError('등록에 실패했습니다. (백엔드 POST 엔드포인트 필요)');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4" style={{ maxWidth: 700 }}>
      <h2>대회 일정 등록</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-2">
          <label>대회명</label>
          <input className="form-control" name="name" value={form.name} onChange={handleChange} required />
        </div>
        <div className="mb-2">
          <label>주최(조직)</label>
          <input className="form-control" name="organization" value={form.organization} onChange={handleChange} required />
        </div>
        <div className="mb-2">
          <label>시작일</label>
          <input type="date" className="form-control" name="startDate" value={form.startDate} onChange={handleChange} required />
        </div>
        <div className="mb-2">
          <label>종료일</label>
          <input type="date" className="form-control" name="endDate" value={form.endDate} onChange={handleChange} required />
        </div>
        <div className="mb-2">
          <label>상태</label>
          <input className="form-control" name="status" value={form.status} onChange={handleChange} required />
        </div>
        <div className="mb-2">
          <label>상세 URL</label>
          <input className="form-control" name="detailUrl" value={form.detailUrl} onChange={handleChange} />
        </div>
        <hr />
        <h5>부서 정보</h5>
        {form.departments.map((dep, idx) => (
          <div key={idx} className="border rounded p-2 mb-2">
            <div className="mb-1">
              <label>부서명</label>
              <input className="form-control" name="department" value={dep.department} onChange={e => handleDeptChange(idx, e)} required />
            </div>
            <div className="mb-1">
              <label>경기일</label>
              <input type="date" className="form-control" name="matchDate" value={dep.matchDate} onChange={e => handleDeptChange(idx, e)} required />
            </div>
            <div className="mb-1">
              <label>장소</label>
              <input className="form-control" name="location" value={dep.location} onChange={e => handleDeptChange(idx, e)} required />
            </div>
            <div className="mb-1">
              <label>상태</label>
              <input className="form-control" name="status" value={dep.status} onChange={e => handleDeptChange(idx, e)} required />
            </div>
            {form.departments.length > 1 && (
              <button type="button" className="btn btn-danger btn-sm mt-1" onClick={() => removeDepartment(idx)}>삭제</button>
            )}
          </div>
        ))}
        <button type="button" className="btn btn-secondary mb-3" onClick={addDepartment}>+ 부서 추가</button>
        <div>
          <button type="submit" className="btn btn-primary" disabled={loading}>등록</button>
        </div>
        {success && <div className="alert alert-success mt-2">등록 성공!</div>}
        {error && <div className="alert alert-danger mt-2">{error}</div>}
      </form>
    </div>
  );
};

export default AddTournament; 